<store-finder class="w-12 p-b-10"
              [showOnlyStores]="true"
              [showStoresWithProductOrRangeAvailable]="true" />